import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  signal,
  ViewChild,
} from '@angular/core';

export enum AccordionStyle {
  normal = 'normal',
  floating = 'floating',
}

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class AccordionComponent {
  @Input()
  title!: string;
  @Input()
  accordionStyle = AccordionStyle.normal;
  @Input()
  expanded = signal(false);
  @Input()
  buttonWidth = '100%';
  @Input()
  contentWidth = '100%';

  @ViewChild('panel', { static: false })
  panelElement!: ElementRef<HTMLDivElement>;
  @ViewChild('button', { static: false })
  buttonElement!: ElementRef<HTMLButtonElement>;

  panelLeft = signal('');

  private readonly _elementRef = inject(ElementRef);

  onToggle(): void {
    this.expanded.set(!this.expanded());
    this.calcPanelLeft();
  }

  calcPanelLeft(): void {
    if (this.expanded() && this.accordionStyle === AccordionStyle.floating) {
      const buttonRect =
        this.buttonElement?.nativeElement?.getBoundingClientRect();
      const panelRect =
        this.panelElement?.nativeElement?.getBoundingClientRect();
      if (buttonRect && panelRect) {
        const diff = panelRect.width - buttonRect.width;
        this.panelLeft.set(`${buttonRect.x - diff}px`);
      }
    }
  }

  getAccordionClass(): string {
    return this.expanded() ? 'active' : null;
  }

  getPanelClass(): string {
    const classList = [];
    if (this.expanded()) {
      classList.push('panel-active');
    }
    if (this.accordionStyle === AccordionStyle.floating) {
      classList.push('panel-floating');
      if (this.expanded()) {
        classList.push('panel-floating-expanded');
      }
    }
    return classList.join(' ');
  }

  getPanelHeight(): string {
    return this.expanded()
      ? `${this.panelElement.nativeElement.scrollHeight}px`
      : null;
  }

  getContainerClass(): string {
    return this.accordionStyle === AccordionStyle.normal ? 'border' : '';
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.calcPanelLeft();
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (
      this.accordionStyle === AccordionStyle.floating &&
      !this._elementRef.nativeElement.contains(event.target)
    ) {
      this.expanded.set(false);
    }
  }
}
